module.exports = __webpack_public_path__ + "static/media/PLASTICO.55732c11.png";